(function() {
'use strict';

angular
    .module('ekh')
    .directive('metaOverride', metaOverride);

function metaOverride() {
    function _linker(scope) {
        const metaInfo = scope.metaInfo;

        $.each({
            'title':
                `<title>${metaInfo.PageTitle}`,
            'meta[name=title]':
                `<meta name="keywords" content="${metaInfo.MetaKeywords || ''}">`,
            'meta[name=description]':
                `<meta name="description" content="${metaInfo.MetaDescription || ''}">`,
            'meta[property="og:description"]':
                `<meta property="og:description" content="${metaInfo.MetaDescription || ''}">`
        },
            (selector, htmlStr) => {
                $(selector).remove();
                $('head').append(htmlStr);
            }
        );
    }

    return {
        restrict: 'E',
        scope: {
            metaInfo: '='
        },
        link: _linker
    };
}
})();
